import {
	Mesh,
	Space,
	Vector3,
	WebXRState,
	Quaternion,
	MeshBuilder,
	WebXRHitTest,
	TransformNode,
	WebXRFeatureName,
	WebXRAnchorSystem,
	WebXRSessionManager,
	Logger,
} from '@babylonjs/core';

import { Button, Control, TextBlock, Rectangle, AdvancedDynamicTexture } from '@babylonjs/gui';

/**
 * Handle AR feature
 */
export class SeadevAR {
	private _xr;
	private _scene;
	private _imagePath;
	private _ssbBuilder;
	private _advancedDynamic;

	/**
	 * Constructor for AR feature
	 *
	 * @param {Class} ssbBuilder Class SeadevShedBuilder
	 */
	constructor(ssbBuilder) {
		this._scene = ssbBuilder._scene;
		this._ssbBuilder = ssbBuilder;
		this._imagePath = this._ssbBuilder._canvas.getAttribute('data-image-path');

		this.runARFeature(this._scene);
	}

	/**
	 * Add AR button
	 */
	runARFeature = async (scene) => {
		const isEnableAR = Number(this._ssbBuilder._canvas.getAttribute('data-model-enable-ar'));
		if (1 !== isEnableAR) {
			return;
		}

		const supported = await WebXRSessionManager.IsSessionSupportedAsync('immersive-ar');

		if (!supported) {
			jQuery('#ar-view-shed-mobile').remove();
			jQuery('#ar-view-shed-desktop').parent().addClass('on-mobile');
			jQuery('#ar-view-shed-desktop').css('opacity', 1);
			return;
		}

		jQuery('#ar-view-shed-desktop').remove();
		jQuery('#ar-view-shed-mobile').css('opacity', 1);
		this._xr = await this._scene.createDefaultXRExperienceAsync({
			uiOptions: {
				sessionMode: 'immersive-ar',
				referenceSpaceType: 'local-floor',
			},
			optionalFeatures: true,
			outputCanvasOptions: {
				canvasOptions: {
					framebufferScaleFactor: 0.3,
					antialias: true,
				},
			},
		});

		this._advancedDynamic = AdvancedDynamicTexture.CreateFullscreenUI('AR_UI', true, scene);

		jQuery('.babylonVRicon').click(() => {
			this.handleAR();
		});
	};

	/**
	 * Handle event on AR
	 */
	handleAR = async () => {
		const _this = this;
		const cloneMeshName = 'bodyMeshClone';
		const arMesh = this._scene.getMeshByName('body_obj') as Mesh;

		for (let i = 0; i < _this._scene.meshes.length; i++) {
			if ('body_obj' === _this._scene.meshes[i].name) {
				continue;
			}

			if (null !== _this._scene.meshes[i].parent) {
				_this._scene.meshes[i]['arMetadata'] = { parent: _this._scene.meshes[i].parent };
			} else {
				_this._scene.meshes[i]['arMetadata'] = { parent: null };
			}

			_this._scene.meshes[i].setParent(arMesh);
		}

		arMesh.setEnabled(false);

		const fm = _this._xr.baseExperience.featuresManager;
		const xrHitTest = fm.enableFeature(WebXRFeatureName.HIT_TEST, 'latest') as WebXRHitTest;
		const xrAnchors = fm.enableFeature(
			WebXRFeatureName.ANCHOR_SYSTEM,
			'latest',
		) as WebXRAnchorSystem;

		const marker = MeshBuilder.CreateTorus(
			'marker',
			{ thickness: 0.007, diameter: 0.3, tessellation: 500 },
			this._scene,
		);
		marker.isVisible = false;
		marker.rotationQuaternion = new Quaternion();

		let hitTest;
		xrHitTest.onHitTestResultObservable.add((results) => {
			if (results.length) {
				marker.isVisible = true;
				hitTest = results[0];
				hitTest.transformationMatrix.decompose(
					undefined,
					marker.rotationQuaternion,
					marker.position,
				);
			} else {
				marker.isVisible = false;
				hitTest = undefined;
			}
		});

		let newMesh;
		let leftButton;
		let rightButton;
		if (xrAnchors) {
			xrAnchors.onAnchorAddedObservable.add(async (anchor) => {
				newMesh = _this._scene.getMeshByName('bodyMeshClone') as Mesh;
				if (newMesh === null || newMesh === undefined) {
					arMesh.setEnabled(true);
					newMesh = arMesh.clone('bodyMeshClone');
					await _this.moveBoneForCloneMesh(newMesh, cloneMeshName);

					// newMesh.scaling = new Vector3( 0.05, 0.05, 0.05 );
					newMesh.scaling = new Vector3(0.3048, 0.3048, 0.3048);

					_this.disposeMeshes([description]);

					if (undefined === leftButton) {
						leftButton = _this.createRotateButton(
							newMesh,
							'Left',
							Control.HORIZONTAL_ALIGNMENT_LEFT,
							Control.VERTICAL_ALIGNMENT_BOTTOM,
							1,
							`${this._imagePath}rotate-left.svg`,
							'24px',
							0,
						) as Button;
					}

					if (undefined === rightButton) {
						rightButton = _this.createRotateButton(
							newMesh,
							'Right',
							Control.HORIZONTAL_ALIGNMENT_RIGHT,
							Control.VERTICAL_ALIGNMENT_BOTTOM,
							-1,
							`${this._imagePath}rotate-right.svg`,
							0,
							'24px',
						) as Button;
					}

					arMesh.setEnabled(false);
				}

				const transformNode = new TransformNode('transformNode', _this._scene);
				newMesh.parent = transformNode;
				anchor.attachedNode = transformNode;
			});

			xrAnchors.onAnchorRemovedObservable.add((anchor) => {
				if (anchor) {
					anchor.attachedNode.dispose();
				}
			});
		}

		let description = _this.createTextBlock() as Rectangle;
		let buttonPlaceModel = _this.addPlaceModelButton() as Button;
		buttonPlaceModel.onPointerDownObservable.add(async () => {
			if (hitTest && xrAnchors && _this._xr.baseExperience.state === WebXRState.IN_XR) {
				xrAnchors.addAnchorPointUsingHitTestResultAsync(hitTest);
			}
		});

		_this._xr.baseExperience.onStateChangedObservable.add((state) => {
			if (state === WebXRState.NOT_IN_XR) {
				_this.disposeMeshes([
					leftButton,
					rightButton,
					description,
					newMesh,
					marker,
					buttonPlaceModel,
				]);
				arMesh.scaling = new Vector3(1, 1, 1);
				const arChildMEshes = arMesh.getChildMeshes();
				arMesh.setEnabled(true);
				for (let i = 0; i < arChildMEshes.length; i++) {
					if (arChildMEshes[i]['arMetadata']) {
						arChildMEshes[i].setParent(arChildMEshes[i]['arMetadata'].parent);
					}
				}
			}
		});
	};

	/**
	 * Check and remove mesh in scene
	 *
	 * @param {Array} mesh mesh need to remove in the scene
	 */
	disposeMeshes = (meshes) => {
		for (let i = 0; i <= meshes.length; i++) {
			if (undefined === meshes[i] || null === meshes[i]) {
				continue;
			}

			meshes[i].dispose();
		}
	};

	/**
	 * Move bone for model after clone
	 *
	 * @param {Object} cloneMesh mesh clone from body_mesh
	 * @param {String} cloneMeshName clone mesh name
	 * @returns {Promise}
	 */
	moveBoneForCloneMesh = (cloneMesh, cloneMeshName) => {
		return new Promise(async (resolve) => {
			const _this = this;
			const childMeshesLv1 = await cloneMesh.getChildMeshes();

			for (let i = 0; i < childMeshesLv1.length; i++) {
				let meshLv1 = childMeshesLv1[i] as Mesh;

				if (
					null !== meshLv1.metadata &&
					undefined !== meshLv1.metadata.updateBone &&
					false === meshLv1.metadata.updateBone
				) {
					continue;
				}

				let lv1Name = meshLv1.name;
				let tmpLv1Name = lv1Name.replace(`${cloneMeshName}.`, '');
				let originMeshLv1 = _this._ssbBuilder.getMeshByName(tmpLv1Name) as Mesh;

				if (null === originMeshLv1 || originMeshLv1.isAnInstance) {
					continue;
				}

				const childMeshesLv2 = await originMeshLv1.getChildMeshes();
				for (let index = 0; index < childMeshesLv2.length; index++) {
					let lv2Name = childMeshesLv2[index].name;
					let meshLv2 = _this._ssbBuilder.getMeshByName(`${lv1Name}.${lv2Name}`) as Mesh;
					let tmpLv2Name = lv2Name.replace(`${cloneMeshName}.`, '');
					let originMeshLv2 = _this._ssbBuilder.getMeshByName(tmpLv2Name) as Mesh;

					if (
						null === originMeshLv2 ||
						originMeshLv2.isAnInstance ||
						null === originMeshLv2.skeleton
					) {
						continue;
					}

					meshLv2.skeleton = originMeshLv2.skeleton;

					const parentBonesLv2 = meshLv2.skeleton.bones;
					for (let j = 0; j < parentBonesLv2.length; j++) {
						if (undefined === parentBonesLv2[j].name) {
							continue;
						}

						meshLv2.skeleton.bones[j].position = parentBonesLv2[j].position;
					}

					const childBonesLv2 = originMeshLv2.skeleton.bones[0].children;
					for (let j = 0; j < childBonesLv2.length; j++) {
						if (undefined === childBonesLv2[j].name) {
							continue;
						}

						meshLv2.skeleton.bones[0].children[j].position = childBonesLv2[j].position;
					}
				}

				if (null === originMeshLv1.skeleton) {
					continue;
				}

				meshLv1.skeleton = originMeshLv1.skeleton;

				const parentBones = meshLv1.skeleton.bones;
				for (let j = 0; j < parentBones.length; j++) {
					if (undefined === parentBones[j].name) {
						continue;
					}

					meshLv1.skeleton.bones[j].position = parentBones[j].position;
				}

				const childBones = originMeshLv1.skeleton.bones[0].children;
				for (let j = 0; j < childBones.length; j++) {
					if (undefined === childBones[j].name) {
						continue;
					}

					meshLv1.skeleton.bones[0].children[j].position = childBones[j].position;
				}
			}

			resolve(true);
		});
	};

	/**
	 * Add button to place model
	 *
	 * @returns {Button}
	 */
	addPlaceModelButton = () => {
		let button = Button.CreateImageOnlyButton(
			`placeModelButton`,
			`${this._imagePath}place-model.svg`,
		);
		button.width = '56px';
		button.height = '76px';
		button.paddingBottom = '20px';
		button.thickness = 0;
		button.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_CENTER;
		button.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;

		this._advancedDynamic.addControl(button);

		return button;
	};

	/**
	 * Create text block for AR mode
	 *
	 * @returns {Rectangle}
	 */
	createTextBlock = () => {
		let rectangle = new Rectangle('AR_wrap_description');
		rectangle.background = 'rgba(0, 0, 0, 0.4)';
		rectangle.width = '250px';
		rectangle.height = '200px';
		rectangle.thickness = 0;
		rectangle.cornerRadius = 6;
		rectangle.paddingBottom = '150px';
		rectangle.verticalAlignment = Control.VERTICAL_ALIGNMENT_BOTTOM;

		let text = new TextBlock('AR_description');
		text.color = 'white';
		text.fontSize = '14px';
		text.textWrapping = true;
		text.text = 'Move camera around to detect ground and place the shed';

		this._advancedDynamic.addControl(rectangle);
		rectangle.addControl(text);

		return rectangle;
	};

	/**
	 * Create button to rotate the model on AR mode
	 *
	 * @param {Object}  mesh body mesh
	 * @param {String}  name button name
	 * @param {Boolean} horizontalAlignment set positon for button follow horizontal
	 * @param {Boolean} verticalAlignment set positon for button follow vertical
	 * @param {Number}  ratioRotate ratio rotate when clicking to button
	 * @param {String}  buttonUrl button link
	 * @param {String}  paddingLeft padding left for button
	 * @param {String}  paddingRight padding right for button
	 * @returns {Button}
	 */
	createRotateButton = (
		mesh,
		name,
		horizontalAlignment,
		verticalAlignment,
		ratioRotate,
		buttonUrl,
		paddingLeft,
		paddingRight,
	) => {
		let button = Button.CreateImageOnlyButton(`${name}Button`, buttonUrl);
		button.paddingLeft = paddingLeft;
		button.paddingRight = paddingRight;
		button.width = '80px';
		button.height = '76px';
		button.paddingBottom = '20px';
		button.thickness = 0;
		button.horizontalAlignment = horizontalAlignment;
		button.verticalAlignment = verticalAlignment;

		button.onPointerUpObservable.add(async () => {
			mesh.rotate(new Vector3(0, ratioRotate, 0), 0.1, Space.WORLD);
		});

		this._advancedDynamic.addControl(button);

		return button;
	};
}
